import { createRobot } from "../../models/Robot";
import { loadModel } from "../connection";
import { BaseDataChannel, ObjectStateManager as ObjectStateManager } from "./BaseDataChannel";
import { createPeerConnection, RTCFeed, setAlternateSignalingUrl } from "./wrtc_connection";
import { SignalingConnection } from "../signaling/SignalingConnection";
import { ControlChannel } from "./ControlChannel";
import { VehicleStatus } from "./dex_interfaces";


export class RobocoreClient {
  public id = '';
  public rtcFeed: RTCFeed | null = null;
  public channels: BaseDataChannel[] = [];
  public onConnectionStateChanged: (state: string) => void = () => { };

  constructor(public stateManager: ObjectStateManager) { }

  public getChannel(name: string) {
    return this.channels.find(c => c.getConfiguration().name === name);
  }

  public async connect(id: string, sessionId: string) {
    this.id = id;
    const robot = createRobot(id);
    await loadModel(robot);
    const rtcGroup = `robocore-${sessionId}`;
    let baseUrl = '';
    if (window.location.href.includes('?signaling=')) {
      const signalingParam = new URLSearchParams(window.location.search).get('signaling');
      baseUrl = `ws://${signalingParam}:28801`;
      setAlternateSignalingUrl(baseUrl);
    }
    this.rtcFeed = await createPeerConnection(
      rtcGroup,
      this.id,
      robot.token,
      dc => {
        // console.log('connecting channel', dc.label);
        const channel = this.getChannel(dc.label);
        if (channel) {
          channel.connect(dc, this.stateManager);
        } else {
          console.error('Channel not found', dc.label);
        }
      }
    );
    if (!this.rtcFeed) {
      throw new Error('Failed to create RTC feed');
    }
    this.rtcFeed.onConnectionStateChanged = (state: string) => {
      console.log('connection state is now:', state);
      this.onConnectionStateChanged(state);
      return false;
    };
    const signaling = new SignalingConnection({
      group: 'robocore',
      deviceId: robot._id,
      token: robot.token,
      baseUrl,
    });
    await signaling.connect();
    signaling.sendReplace({ connect: sessionId });
    signaling.close();
  }

  public sendControlChannelRequest(req: Partial<VehicleStatus>) {
    const channel = this.getChannel('control') as ControlChannel;
    if (channel) {
      channel.sendRequest(req);
    } else {
      console.error('Control channel not found');
    }
  }

  public async disconnect() {
    console.log(`disconnecting from robocore: ${this.id}`);
    try {
      this.onConnectionStateChanged('disconnected');
      this.rtcFeed?.signalingConnection.sendReplace({ disconnect: true });
      this.rtcFeed?.peerConnection.close();
      this.rtcFeed?.signalingConnection.close();
    } catch (e) {
      console.error(e);
    }
  }
}